import Container from "./Container";
import Header from "./Header";
import Layout from "./Layout";
import { Provider } from "react-redux";
import store from "../redux/store";

const App = () => {
  return (
    <Provider store={store}>
      <Layout>
        <Header />
        <Container />
      </Layout>
    </Provider>
  );
};

export default App;
